import { takeLatest, put } from 'redux-saga/effects'
import { createReducer, makeAction, makeKeys, urlWithPrefix } from './helper'
import { httpPost, httpGet, httpPut, httpDelete } from 'core/restClient'
import { appLoading, appLoaded, toastError, toastSuccess } from './app'
import { vmPath, homePath, vmEditPath, supplierPath, supplierConvertPath, vmDetailPath } from 'routes'

import r from 'reactotron-react-js'

const FETCH_VMA = makeKeys('FETCH_VMA')
const CREATE_VMA = makeKeys('CREATE_VMA')
const UPLOAD_VMA_ATTACHMENTS = makeKeys('UPLOAD_VMA_ATTACHMENTS')
const GET_VMA_ATTACHMENT_GROUP = makeKeys('GET_VMA_ATTACHMENT_GROUP')
const GET_VMA_FORM_DATA = makeKeys('GET_VMA_FORM_DATA')
const GET_SUPPLIER_FORM_DATA = makeKeys('GET_SUPPLIER_FORM_DATA')
const CLEAR_VMA_FORM_DATA = 'CLEAR_VMA_FORM_DATA'
const UPDATE_VMA = makeKeys('UPDATE_VMA')
const SUBMIT_VMA = makeKeys('SUBMIT_VMA')
const ACTION_VMA = makeKeys('ACTION_VMA')
const GET_BP_DATA = makeKeys('GET_BP_DATA')
const GET_BP_COMPANIES = makeKeys('GET_BP_COMPANIES')
const GET_BP_GENERAL_VIEW = makeKeys('GET_BP_GENERAL_VIEW')
const GET_BP_PURCHASING_ORGS = makeKeys('GET_BP_PURCHASING_ORGS')
const GET_BP_PURCHASING_VIEW = makeKeys('GET_BP_PURCHASING_VIEW')
const GET_BP_ACCOUNTING_VIEW = makeKeys('GET_BP_ACCOUNTING_VIEW')
const DELETE_VMA = makeKeys('DELETE_VMA')
const GET_VMA_WORKFLOW = makeKeys('GET_VMA_WORKFLOW')
const GET_VMA_WORKFLOW_EDIT = makeKeys('GET_VMA_WORKFLOW_EDIT')
const GET_LAST_VENDOR_CODE = makeKeys('GET_LAST_VENDOR_CODE')
const CHECK_EMAIL_AVAILABLE = makeKeys('CHECK_EMAIL_AVAILABLE')
const CHECK_TAX_ID_AVAILABLE = makeKeys('CHECK_TAX_ID_AVAILABLE')
const GET_BUSINESS_GROUPS = makeKeys('GET_BUSINESS_GROUPS')

export const fetchVM = makeAction(FETCH_VMA.REQUEST, 'query')
export const createVM = makeAction(CREATE_VMA.REQUEST, 'data', 'submit', 'history', 'showAppLoading')
export const uploadAttachments = makeAction(UPLOAD_VMA_ATTACHMENTS.REQUEST, 'id', 'data', 'submit', 'comment', 'history', 'showAppLoading', 'actionDocument', 'supplierAction')
export const getAttachmentGroups = makeAction(GET_VMA_ATTACHMENT_GROUP.REQUEST, 'query')
export const getVMFormData = makeAction(GET_VMA_FORM_DATA.REQUEST, 'id', 'history')
export const getSupplierFormData = makeAction(GET_SUPPLIER_FORM_DATA.REQUEST, 'id', 'history')
export const clearVMFormData = makeAction(CLEAR_VMA_FORM_DATA)
export const updateVM = makeAction(UPDATE_VMA.REQUEST, 'data', 'submit', 'history', 'showAppLoading', 'actionDocument', 'supplierAction')
export const submitVM = makeAction(SUBMIT_VMA.REQUEST, 'id', 'history', 'supplierAction')
export const actionVM = makeAction(ACTION_VMA.REQUEST, 'data', 'history')
export const getBPData = makeAction(GET_BP_DATA.REQUEST, 'vendorCode', 'companyCode', 'onGetDataSuccess')
export const getBPCompanies = makeAction(GET_BP_COMPANIES.REQUEST, 'vendorCode')
export const getBPGeneralView = makeAction(GET_BP_GENERAL_VIEW.REQUEST, 'vendorCode', 'companyCode', 'onGetDataSuccess', 'onGetDataWarning', 'id')
export const getBPPurchasingOrgs = makeAction(GET_BP_PURCHASING_ORGS.REQUEST, 'vendorCode')
export const getBPPurchasingView = makeAction(GET_BP_PURCHASING_VIEW.REQUEST, 'vendorCode', 'purchasingOrg', 'onGetDataSuccess')
export const getBPAccountingView = makeAction(GET_BP_ACCOUNTING_VIEW.REQUEST, 'vendorCode', 'companyCode', 'onGetDataSuccess')
export const deleteVM = makeAction(DELETE_VMA.REQUEST, 'id', 'history', 'closeConfirmModal')
export const getWorkflow = makeAction(GET_VMA_WORKFLOW.REQUEST, 'id')
export const getWorkflowEditMode = makeAction(GET_VMA_WORKFLOW_EDIT.REQUEST, 'data')
export const getLastVendorCode = makeAction(GET_LAST_VENDOR_CODE.REQUEST, 'accountGroup', 'onGetSuccess')
export const checkEmailAvailable = makeAction(CHECK_EMAIL_AVAILABLE.REQUEST, 'email', 'onGetDataSuccess')
export const checkTaxIdAvailable = makeAction(CHECK_TAX_ID_AVAILABLE.REQUEST, 'data', 'onTaxIdAvailable', 'onTaxNotIdAvailable')
export const getBusinessGroups = makeAction(GET_BUSINESS_GROUPS.REQUEST)

const fetchVMSuccess = makeAction(FETCH_VMA.SUCCESS, 'data')
const getAttachmentGroupsSuccess = makeAction(GET_VMA_ATTACHMENT_GROUP.SUCCESS, 'data')
const getVMFormDataSuccess = makeAction(GET_VMA_FORM_DATA.SUCCESS, 'data')
const getSupplierFormDataSuccess = makeAction(GET_SUPPLIER_FORM_DATA.SUCCESS, 'data')
const getBPCompaniesSuccess = makeAction(GET_BP_COMPANIES.SUCCESS, 'data')
const getBPPurchasingOrgsSuccess = makeAction(GET_BP_PURCHASING_ORGS.SUCCESS, 'data')
const getWorkflowSuccess = makeAction(GET_VMA_WORKFLOW.SUCCESS, 'data')
const getWorkflowEditModeSuccess = makeAction(GET_VMA_WORKFLOW_EDIT.SUCCESS, 'data')
const getLastVendorCodeSuccess = makeAction(GET_LAST_VENDOR_CODE.SUCCESS, 'data')
const checkEmailAvailableSuccess = makeAction(CHECK_EMAIL_AVAILABLE.SUCCESS, 'data', 'email')
const getBusinessGroupsSuccess = makeAction(GET_BUSINESS_GROUPS.SUCCESS, 'data')

const vmApiPath = path => path ? urlWithPrefix(`vendorMaintenances/${path}`) : urlWithPrefix('vendorMaintenances')
const multipartHeader = { 'Content-Type': 'multipart/form-data', }

function* fetchVMRequest(action) {
  const { query } = action.payload
  try {
    yield put(appLoading('Loading Vendor Maintenance Data.'))
    const response = yield httpGet(vmApiPath(), query)
    yield put(appLoaded())
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(fetchVMSuccess(response.data))
      }
    }
  } catch (e) {
    yield put(appLoaded())
    if (e && e.config && e.config.headers && e.config.headers.Authorization === 'Bearer null') {
      yield put(fetchVM(query))
    } else {
      if (e && e.data && e.data.message) {
        yield put(toastError(e.data.message))
      } else {
        yield put(toastError('Load vendor maintenance data error!'))
      }
    }
  }
}

function* createVMRequest(action) {
  const { data, submit, history, showAppLoading } = action.payload
  try {
    yield put(appLoading('Save vendor maintenance data.'))
    const response = yield httpPost(vmApiPath(), data)
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        const id = response.data
        var attachmentsData = {}
        if (data.VMA01) attachmentsData.VMA01 = data.VMA01
        if (data.VMA02) attachmentsData.VMA02 = data.VMA02
        if (data.VMA03) attachmentsData.VMA03 = data.VMA03
        if (data.VMA04) attachmentsData.VMA04 = data.VMA04
        if (data.VMA05) attachmentsData.VMA05 = data.VMA05
        if (data.VMA06) attachmentsData.VMA06 = data.VMA06
        if (data.VMA07) attachmentsData.VMA07 = data.VMA07
        if (data.VMA08) attachmentsData.VMA08 = data.VMA08
        if (data.VMA16) attachmentsData.VMA16 = data.VMA16
        if (data.VMA17) attachmentsData.VMA17 = data.VMA17

        yield put(uploadAttachments(id, attachmentsData, submit, '', history, showAppLoading))
      } else {
        yield put(appLoaded())
        yield put(toastError('Save vendor maintenance data fail.'))
      }
    }
  } catch (e) {
    yield put(appLoaded())
    yield put(toastError('Save vendor maintenance data fail.'))
  }
}

function* uploadAttachmentsRequest(action) {
  const { id, data, submit, history, comment, showAppLoading, actionDocument, supplierAction } = action.payload

  const config = {
    onUploadProgress: (progressEvent) => {
      var percentCompleted = ((progressEvent.loaded * 100) / progressEvent.total).toFixed(2).replace('.00', '')
      var uploaded = (progressEvent.loaded / 1024).toFixed(2).replace('.00', '')
      var total = (progressEvent.total / 1024).toFixed(2).replace('.00', '')
      var uploadProgress = `${percentCompleted}% (${uploaded} KB / ${total} KB)`
      showAppLoading(`Upload attachments. ${uploadProgress}`)
    }
  }

  try {
    yield put(appLoading(`Upload attachments.`))
    const response = yield httpPost(vmApiPath(`${id}/attachments`), data, multipartHeader, config)
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        if (submit) {
          yield put(submitVM(id, history, supplierAction))
        } else {
          if (actionDocument !== undefined) {
            actionDocument()
          } else {
            yield put(toastSuccess('Save vendor maintenance data success.'))
            yield put(appLoaded())
            history.push(vmPath)
          }
        }
      }
    }
  } catch (e) {
    yield put(appLoaded())
    history.push(vmEditPath(id))
    yield put(toastError('Upload attachments data fail.'))
  }
}

function* getAttachmentGroupsRequest(action) {
  try {
    const response = yield httpGet(vmApiPath('attachmentGroups'))
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(getAttachmentGroupsSuccess(response.data))
      }
    }
  } catch (e) {
    if (e && e.config && e.config.headers && e.config.headers.Authorization === 'Bearer null') {
      yield put(getAttachmentGroups())
    } else {
      yield put(getAttachmentGroupsSuccess([]))
    }
  }
}

function* getSupplierFormDataRequest(action) {
  const { id, history } = action.payload
  try {
    yield put(appLoading(`Loading supplier data.`))
    const response = yield httpGet(vmApiPath(`suppliers/${id}/formData`))
    yield put(appLoaded())
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        let data = { ...response.data }
        // set typeOfBusiness
        if (data.typeOfBusiness) {
          data.typeOfBusiness = data.typeOfBusiness.split(',')
        }
        // set typeOfVendor
        if (data.typeOfVendor) {
          let x = data.typeOfVendor.split(',')
          data.typeOfVendor = {}
          x.forEach(x => {
            if (x == 'Consultant') {
              data.typeOfVendor.Consultant = true
            }
            if (x == 'Designer') {
              data.typeOfVendor.Designer = true
            }
            if (x == 'ContractorSubContractor') {
              data.typeOfVendor.ContractorSubContractor = true
            }
            if (x == 'SupplierDealer') {
              data.typeOfVendor.SupplierDealer = true
            }
            if (x == 'Factory') {
              data.typeOfVendor.Factory = true
            }
            if (x == 'Other') {
              data.typeOfVendor.Other = true
            }
          })
        }
        //set dealerName
        data.listDealer = []
        if (data.dealerName) {
          let x = data.dealerName.split(',')
          x.forEach(x => {
            data.listDealer.push({ dealerName: x })
          })
        }
        data.projectReference = data.projectReference?JSON.parse(data.projectReference):[]
        data.income = data.income?JSON.parse(data.income):[]
        data.currentRatio = data.currentRatio?JSON.parse(data.currentRatio):[]
        data.profit = data.profit?JSON.parse(data.profit):[]
        data.shareholder = data.shareholder?JSON.parse(data.shareholder):[]
        data.vendorAuthorizedDirector = data.vendorAuthorizedDirector?JSON.parse(data.vendorAuthorizedDirector):[]
        data.vendorSalePerson = data.vendorSalePerson?JSON.parse(data.vendorSalePerson):[]
        yield put(getSupplierFormDataSuccess(data))
      }
    }
  } catch (e) {
    yield put(appLoaded())
    if (e && e.config && e.config.headers && e.config.headers.Authorization === 'Bearer null') {
      yield put(getSupplierFormData(id, history))
    } else {
      yield put(getSupplierFormDataSuccess({}))
      if (history) {
        history.push(supplierPath)
      }
      yield put(toastError(e.data.message))
    }
  }
}

function* getVMFormDataRequest(action) {
  const { id, history } = action.payload
  try {
    yield put(appLoading(`Loading vendor maintenance data.`))
    const response = yield httpGet(vmApiPath(`${id}/formData`))
    yield put(appLoaded())
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        let data = { ...response.data }
        let username = localStorage.getItem('username').toLowerCase()
        if (((data.status == 0 && (username === data.createdBy.toLowerCase())) ||
          (data.status == 5 && (username === data.createdBy.toLowerCase() || username === data.requesterUser.toLowerCase())))||
          data.status == 10 || data.status == 11) {
          //r.log('do nothing')
        } else {
          history.push(vmDetailPath(id))
        }

        // set typeOfBusiness
        if (data.typeOfBusiness) {
          data.typeOfBusiness = data.typeOfBusiness.split(',')
        } else {
          data.typeOfBusiness = []
        }
        // set typeOfVendor
        if (data.typeOfVendor) {
          let x = data.typeOfVendor.split(',')
          data.typeOfVendor = {}
          x.forEach(x => {
            if (x == 'Consultant') {
              data.typeOfVendor.Consultant = true
            }
            if (x == 'Designer') {
              data.typeOfVendor.Designer = true
            }
            if (x == 'ContractorSubContractor') {
              data.typeOfVendor.ContractorSubContractor = true
            }
            if (x == 'SupplierDealer') {
              data.typeOfVendor.SupplierDealer = true
            }
            if (x == 'Factory') {
              data.typeOfVendor.Factory = true
            }
            if (x == 'Other') {
              data.typeOfVendor.Other = true
            }
          })
        }
        //set dealerName
        data.listDealer = []
        if (data.dealerName) {
          let x = data.dealerName.split(',')
          x.forEach(x => {
            data.listDealer.push({ dealerName: x })
          })
        }
        yield put(getVMFormDataSuccess(data))
      }
    }
  } catch (e) {
    yield put(appLoaded())
    if (e && e.config && e.config.headers && e.config.headers.Authorization === 'Bearer null') {
      yield put(getVMFormData(id, history))
    } else {
      yield put(getVMFormDataSuccess({}))
      if (history) {
        history.push(vmPath)
      }
      yield put(toastError(e.data.message))
    }
  }
}

function* updateVMRequest(action) {
  const { data, submit, history, showAppLoading, actionDocument, supplierAction } = action.payload
  const { id } = data
  try {
    yield put(appLoading('Update vendor maintenance data.'))
    //set paymentType
    let paymentType = []
    if (data.paymentTypeTransfer) {
      paymentType.push('transfer')
    }
    if (data.paymentTypeCheque) {
      paymentType.push('cheque')
    }
    if (data.paymentTypeTTLC) {
      paymentType.push('ttlc')
    }
    //set type of vendor
    let typeOfVendorKeys = Object.keys(data.typeOfVendor || {})
    let typeOfVendor = ''
    typeOfVendorKeys.forEach(x => {
      if (data.typeOfVendor[x]) {
        typeOfVendor += `,${x}`
      }
    })
    typeOfVendor = typeOfVendor.substring(0, 0) + '' + typeOfVendor.substring(0 + 1);
    //set type of business
    let typeOfBusiness = ''
    data.typeOfBusiness.forEach(x => {
      typeOfBusiness += `,${x}`
    })
    typeOfBusiness = typeOfBusiness.substring(0, 0) + '' + typeOfBusiness.substring(0 + 1);
    //set dealerName
    let dealerName = ''
    if (data.listDealer) {
      data.listDealer.forEach(x => {
        if (!x.deleted) {
          dealerName += `,${x.dealerName}`
        }
      })
    }
    dealerName = dealerName.substring(0, 0) + '' + dealerName.substring(0 + 1);

    //set Project Reference
    let projectReference = ''
    if(data.projectReference&&data.projectReference.length>0){
      projectReference = JSON.stringify(data.projectReference.filter(x=>x.projectName.trim().length>0))
    }
    //set Income
    let income = ''
    if(data.income&&data.income.length>0){
      income = JSON.stringify(data.income.filter(x=>x.income>0&&x.year))
    }
    //set Current ratio
    let currentRatio = ''
    if(data.currentRatio&&data.currentRatio.length>0){
      currentRatio = JSON.stringify(data.currentRatio.filter(x=>x.ratio>0&&x.year))
    }
    //set Profit
    let profit = ''
    if(data.profit&&data.profit.length>0){
      profit = JSON.stringify(data.profit.filter(x=>x.profit>0&&x.year))
    }
    //set Shareholder
    let shareholder = ''
    if(data.shareholder&&data.shareholder.length>0){
      shareholder = JSON.stringify(data.shareholder.filter(x=>x.ratio>0&&x.year))
    }
    //set Authorized Director
    let vendorAuthorizedDirector = ''
    if(data.vendorAuthorizedDirector&&data.vendorAuthorizedDirector.length>0){
      vendorAuthorizedDirector = JSON.stringify(data.vendorAuthorizedDirector)
    }
    //set VendorSalePerson
    let vendorSalePerson = ''
    if(data.vendorAuthorizedDirector&&data.vendorSalePerson.length>0){
      vendorSalePerson = JSON.stringify(data.vendorSalePerson)
    }

    const response = yield httpPut(vmApiPath(`${id}`), {
      ...data,
      paymentType: paymentType,
      typeOfVendor: typeOfVendor,
      typeOfBusiness: typeOfBusiness,
      dealerName: dealerName,
      projectReference: projectReference,
      income: income,
      currentRatio: currentRatio,
      profit: profit,
      shareholder: shareholder,
      vendorAuthorizedDirector:vendorAuthorizedDirector,
      vendorSalePerson:vendorSalePerson
    })
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        var attachmentsData = {}
        if (data.VMA01) attachmentsData.VMA01 = data.VMA01
        if (data.VMA02) attachmentsData.VMA02 = data.VMA02
        if (data.VMA03) attachmentsData.VMA03 = data.VMA03
        if (data.VMA04) attachmentsData.VMA04 = data.VMA04
        if (data.VMA05) attachmentsData.VMA05 = data.VMA05
        if (data.VMA06) attachmentsData.VMA06 = data.VMA06
        if (data.VMA07) attachmentsData.VMA07 = data.VMA07
        if (data.VMA08) attachmentsData.VMA08 = data.VMA08
        if (data.VMA16) attachmentsData.VMA16 = data.VMA16
        if (data.VMA17) attachmentsData.VMA17 = data.VMA17

        if (Object.keys(attachmentsData).length) {
          yield put(uploadAttachments(id, attachmentsData, submit, '', history, showAppLoading, actionDocument, supplierAction))
        } else {
          if (submit) {
            yield put(submitVM(id, history, supplierAction))
          } else {
            if (actionDocument !== undefined) {
              actionDocument()
            } else {
              yield put(appLoaded())
              history.push(vmPath)
            }
          }
        }
      } else {
        yield put(appLoaded())
        yield put(toastError('Update vendor maintenance data fail.'))
      }
    }
  } catch (e) {
    yield put(appLoaded())
    if (supplierAction) {
      yield put(toastError(e.data.message || 'Convert supplier fail.'))
    }
  }
}

function* submitVMRequest(action) {
  const { id, history, supplierAction } = action.payload
  try {
    yield put(appLoading('Submit vendor maintenance data.'))
    const response = yield httpPost(vmApiPath(`${id}/submit`))
    yield put(appLoaded())
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        history.push(vmPath)
        if (supplierAction) {
          yield put(toastSuccess('Convert supplier success'))
        }
      } else {
        yield put(toastError('Submit vendor maintenance data fail.'))
      }
    }
  } catch (e) {
    yield put(appLoaded())
    if (supplierAction) {
      history.push(supplierConvertPath(id))
    } else {
      history.push(vmEditPath(id))
    }
    yield put(toastError(e.data.message))
  }
}

function* getBPDataRequest(action) {
  const { vendorCode, companyCode, onGetDataSuccess } = action.payload
  try {
    yield put(appLoading(`Loading business partner data.`))
    const response = yield httpGet(vmApiPath(`businessPartner/${vendorCode}/company/${companyCode}`))
    yield put(appLoaded())
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        onGetDataSuccess(response.data)
      } else {
        put(toastError('Loading business partner data fail'))
      }
    }
  } catch (e) {
    yield put(appLoaded())
  }
}

function* getBPGeneralViewRequest(action) {
  const { vendorCode, companyCode, onGetDataSuccess, onGetDataWarning, id=0 } = action.payload
  try {
    yield put(appLoading(`Loading business partner data.`))
    const response = yield httpGet(vmApiPath(`businessPartner/${vendorCode}`), { companyCode, id })
    yield put(appLoaded())
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        if (response.data.warningMessage) {
          onGetDataWarning(response.data.warningMessage)
        } else {
          onGetDataSuccess(response.data)
        }
      } else {
        put(toastError('Loading business partner data fail'))
      }
    }
  } catch (e) {
    yield put(appLoaded())
  }
}

function* getBPCompaniesRequest(action) {
  const { vendorCode } = action.payload
  try {
    const response = yield httpGet(vmApiPath(`businessPartner/${vendorCode}/company`))
    yield put(appLoaded())
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(getBPCompaniesSuccess({ data: response.data, vendorCode }))
      }
    }
  } catch (e) {
    yield put(appLoaded())
  }
}

function* getBPPurchasingOrgsRequest(action) {
  const { vendorCode } = action.payload
  try {
    const response = yield httpGet(vmApiPath(`businessPartner/${vendorCode}/purchasingOrg`))
    yield put(appLoaded())
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(getBPPurchasingOrgsSuccess(response.data))
      }
    }
  } catch (e) {
    yield put(appLoaded())
  }
}

function* getBPPurchasingViewRequest(action) {
  const { vendorCode, purchasingOrg, onGetDataSuccess } = action.payload
  try {
    yield put(appLoading('Loading Purchasing View Data.'))
    const response = yield httpGet(vmApiPath(`businessPartner/${vendorCode}/purchasingView`), { purchasingOrg })
    yield put(appLoaded())
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        onGetDataSuccess(response.data)
      }
    }
  } catch (e) {
    yield put(appLoaded())
  }
}

function* getBPAccountingViewRequest(action) {
  const { vendorCode, companyCode, onGetDataSuccess } = action.payload
  try {
    yield put(appLoading('Loading Accounting View Data.'))
    const response = yield httpGet(vmApiPath(`businessPartner/${vendorCode}/accountingView`), { companyCode })
    yield put(appLoaded())
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        onGetDataSuccess(response.data)
      }
    }
  } catch (e) {
    yield put(appLoaded())
  }
}

function* deleteVMRequest(action) {
  const { id, history, closeConfirmModal } = action.payload
  try {
    yield put(appLoading('Delete vendor maintenance data.'))
    const response = yield httpDelete(vmApiPath(`${id}`))
    yield put(appLoaded())
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(toastSuccess('Delete vendor maintenance data success.'))
        history.push(vmPath)
      } else {
        yield put(toastError('Delete vendor maintenance data fail.'))
      }
    }
  } catch (e) {
    yield put(appLoaded())
    yield put(toastError(e.data.message))
  }
}

function* getWorkflowRequest(action) {
  const { id } = action.payload
  try {
    const response = yield httpGet(vmApiPath('workflowApproverViewMode'), { id })
    yield put(appLoaded())
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(getWorkflowSuccess(response.data))
      }
    }
  } catch (e) {
    yield put(appLoaded())
    if (e && e.config && e.config.headers && e.config.headers.Authorization === 'Bearer null') {
      yield put(getWorkflow(id))
    } else {
      yield put(getWorkflowSuccess([]))
    }
  }
}

function* getWorkflowEditModeRequest(action) {
  const { creator, requester, purpose, companyCode } = action.payload.data
  try {
    const response = yield httpGet(vmApiPath('workflowApproverEditMode'), { creator, requester, purpose, companyCode })
    yield put(appLoaded())
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(getWorkflowEditModeSuccess(response.data))
      }
    }
  } catch (e) {
    yield put(appLoaded())
    yield put(getWorkflowEditModeSuccess([]))
  }
}

function* actionVMRequest(action) {
  const { data, history } = action.payload
  try {
    yield put(appLoading())
    const response = yield httpPost(vmApiPath(`${data.docId}/action`), data, multipartHeader)
    if (response.status >= 200 && response.status < 300) {
      yield put(appLoaded())
      if (history.location.search.includes('h=true')) {
        history.push(homePath)
      } else {
        history.push(vmPath)
      }
      yield put(toastSuccess('Action vendor maintenance success.'))
    }
  } catch (e) {
    yield put(toastError(e.data.message || 'Action vendor maintenance fail.'))
    yield put(appLoaded())
  }
}

function* getLastVendorCodeRequest(action) {
  const { accountGroup, onGetSuccess } = action.payload
  try {
    yield put(appLoading('Get Available Number'))
    const response = yield httpGet(vmApiPath(`lastVendorCode/${accountGroup}`))
    yield put(appLoaded())
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        if (accountGroup === 'ZEMP') {
          onGetSuccess(response.data)
        } else {
          if (parseInt(response.data)) {
            onGetSuccess(`${parseInt(response.data) + 1}`)
          }
        }
        yield put(getLastVendorCodeSuccess(response.data))
      }
    }
  } catch (e) {
    yield put(appLoaded())
  }
}

function* checkEmailAvailableRequest(action) {
  const { email, onGetDataSuccess } = action.payload
  try {
    const response = yield httpGet(vmApiPath(`checkEmailIsAvailable`), { email })
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(checkEmailAvailableSuccess(response.data, email))
        onGetDataSuccess(email, response.data.success, response.data.message)
      }
    }
  } catch (e) {
    yield put(appLoaded())
  }
}

function* checkTaxIdAvailableRequest(action) {
  const { data: { vendorCode, vendorType, taxId, accountGroup }, onTaxIdAvailable, onTaxNotIdAvailable } = action.payload
  try {
    yield put(appLoading('Checking data.'))
    const response = yield httpGet(vmApiPath(`checkTaxIdIsAvailable`), { vendorCode: vendorCode || '', vendorType, taxId, accountGroup })
    yield put(appLoaded())
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        if (response.data.success) {
          onTaxIdAvailable()
        } else {
          onTaxNotIdAvailable(response.data.message)
        }
      }
    }
  } catch (e) {
    yield put(appLoaded())
  }
}

function* getBusinessGroupsRequest(action) {
  try {
    const response = yield httpGet(vmApiPath(`businessGroups`))
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(getBusinessGroupsSuccess(response.data))
      }
    }
  } catch (e) {
    if (e && e.config && e.config.headers && e.config.headers.Authorization === 'Bearer null') {
      yield put(getBusinessGroups())
    }
  }
}

export function* watchVendorMaintenanceSaga() {
  yield takeLatest(FETCH_VMA.REQUEST, fetchVMRequest)
  yield takeLatest(CREATE_VMA.REQUEST, createVMRequest)
  yield takeLatest(UPLOAD_VMA_ATTACHMENTS.REQUEST, uploadAttachmentsRequest)
  yield takeLatest(GET_VMA_ATTACHMENT_GROUP.REQUEST, getAttachmentGroupsRequest)
  yield takeLatest(GET_VMA_FORM_DATA.REQUEST, getVMFormDataRequest)
  yield takeLatest(GET_SUPPLIER_FORM_DATA.REQUEST, getSupplierFormDataRequest)
  yield takeLatest(UPDATE_VMA.REQUEST, updateVMRequest)
  yield takeLatest(SUBMIT_VMA.REQUEST, submitVMRequest)
  yield takeLatest(GET_BP_DATA.REQUEST, getBPDataRequest)
  yield takeLatest(GET_BP_COMPANIES.REQUEST, getBPCompaniesRequest)
  yield takeLatest(GET_BP_GENERAL_VIEW.REQUEST, getBPGeneralViewRequest)
  yield takeLatest(GET_BP_PURCHASING_ORGS.REQUEST, getBPPurchasingOrgsRequest)
  yield takeLatest(GET_BP_PURCHASING_VIEW.REQUEST, getBPPurchasingViewRequest)
  yield takeLatest(GET_BP_ACCOUNTING_VIEW.REQUEST, getBPAccountingViewRequest)
  yield takeLatest(DELETE_VMA.REQUEST, deleteVMRequest)
  yield takeLatest(GET_VMA_WORKFLOW.REQUEST, getWorkflowRequest)
  yield takeLatest(GET_VMA_WORKFLOW_EDIT.REQUEST, getWorkflowEditModeRequest)
  yield takeLatest(ACTION_VMA.REQUEST, actionVMRequest)
  yield takeLatest(GET_LAST_VENDOR_CODE.REQUEST, getLastVendorCodeRequest)
  yield takeLatest(CHECK_EMAIL_AVAILABLE.REQUEST, checkEmailAvailableRequest)
  yield takeLatest(CHECK_TAX_ID_AVAILABLE.REQUEST, checkTaxIdAvailableRequest)
  yield takeLatest(GET_BUSINESS_GROUPS.REQUEST, getBusinessGroupsRequest)
}

const initial = {
  listVendorMaintenance: { data: {}, loading: false },
  attachmentGroups: { data: [], loading: false },
  formData: { data: {}, loading: false },
  vendorCompanies: { data: [], loading: false, vendorCode: '' },
  vendorPurchasingOrgs: { data: [], loading: false },
  workflow: { data: [], loading: false },
  workflowEdit: { data: [], loading: false },
  lastVendorCode: { data: '', loading: false },
  emailChecking: { email: '', isAvailable: true, message: '', loading: false },
  businessGroups: { data: [], loading: false },
}

export default createReducer(initial, state => ({
  [FETCH_VMA.REQUEST]: () => ({
    ...state,
    listVendorMaintenance: { data: [], loading: true }
  }),
  [FETCH_VMA.SUCCESS]: (data) => ({
    ...state,
    listVendorMaintenance: { data: data.data, loading: false }
  }),
  [GET_VMA_ATTACHMENT_GROUP.REQUEST]: () => ({
    ...state,
    attachmentGroups: { data: [], loading: true }
  }),
  [GET_VMA_ATTACHMENT_GROUP.SUCCESS]: (data) => ({
    ...state,
    attachmentGroups: { data: data.data, loading: false }
  }),
  [GET_SUPPLIER_FORM_DATA.REQUEST]: () => ({
    ...state,
    formData: { data: {}, loading: true }
  }),
  [GET_SUPPLIER_FORM_DATA.SUCCESS]: (data) => ({
    ...state,
    formData: { data: data.data, loading: false }
  }),
  [GET_VMA_FORM_DATA.REQUEST]: () => ({
    ...state,
    formData: { data: {}, loading: true }
  }),
  [GET_VMA_FORM_DATA.SUCCESS]: (data) => ({
    ...state,
    formData: { data: data.data, loading: false }
  }),
  [CLEAR_VMA_FORM_DATA]: () => ({
    ...state,
    formData: { data: {}, loading: false },
    workflow: { data: [], loading: false },
    workflowEdit: { data: [], loading: false },
  }),
  [GET_BP_COMPANIES.REQUEST]: (data) => ({
    ...state,
    vendorCompanies: { data: [], loading: true, vendorCode: data.vendorCode }
  }),
  [GET_BP_COMPANIES.SUCCESS]: (data) => ({
    ...state,
    vendorCompanies: { data: data.data.data, loading: false, vendorCode: data.data.vendorCode }
  }),
  [GET_BP_PURCHASING_ORGS.REQUEST]: () => ({
    ...state,
    vendorPurchasingOrgs: { data: [], loading: true }
  }),
  [GET_BP_PURCHASING_ORGS.SUCCESS]: (data) => ({
    ...state,
    vendorPurchasingOrgs: { data: data.data, loading: false }
  }),
  [GET_VMA_WORKFLOW.REQUEST]: () => ({
    ...state,
    workflow: { data: [], loading: true }
  }),
  [GET_VMA_WORKFLOW.SUCCESS]: (data) => ({
    ...state,
    workflow: { data: data.data, loading: false }
  }),
  [GET_VMA_WORKFLOW_EDIT.REQUEST]: () => ({
    ...state,
    workflowEdit: { data: [], loading: true }
  }),
  [GET_VMA_WORKFLOW_EDIT.SUCCESS]: (data) => ({
    ...state,
    workflowEdit: { data: data.data, loading: false }
  }),
  [GET_LAST_VENDOR_CODE.REQUEST]: () => ({
    ...state,
    lastVendorCode: { data: '', loading: true }
  }),
  [GET_LAST_VENDOR_CODE.SUCCESS]: (data) => ({
    ...state,
    lastVendorCode: { data: data.data, loading: false }
  }),
  [CHECK_EMAIL_AVAILABLE.REQUEST]: (data) => ({
    ...state,
    emailChecking: { email: data.email, isAvailable: true, message: '', loading: true }
  }),
  [CHECK_EMAIL_AVAILABLE.SUCCESS]: (data) => ({
    ...state,
    emailChecking: { email: data.email, isAvailable: data.data.success, message: data.data.message, loading: false }
  }),
  [GET_BUSINESS_GROUPS.REQUEST]: () => ({
    ...state,
    businessGroups: { data: [], loading: true }
  }),
  [GET_BUSINESS_GROUPS.SUCCESS]: (data) => ({
    ...state,
    businessGroups: { data: data.data, loading: false }
  }),
}))